import PortfolioPageLayout from "../PortfolioPageLayout";
import neurotypeData from "../Neurotype/neurotypeData";

function Neurotype() {
  return <PortfolioPageLayout {...neurotypeData} />;
}

export default Neurotype;
